import React from 'react'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TkuIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <G clipPath='url(#clip0_10859_99577)'>
                <Path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 12H24V24H0V12H3V8H8V12ZM7.428 15.317V14H1V15.317H3.385V21.892H5.01V15.317H7.428ZM10.827 18.727L12.854 21.892H14.789L11.905 17.507L14.707 14H12.707L10.697 16.596L9.981 17.577V14H8.355V21.892H9.981V19.637L10.827 18.727ZM21.374 14H19.743V19.252C19.728 20.213 19.263 20.694 18.35 20.694C17.912 20.694 17.57 20.575 17.322 20.339C17.075 20.102 16.952 19.725 16.952 19.209V14H15.325V19.257C15.336 20.11 15.612 20.78 16.155 21.268C16.696 21.756 17.428 22 18.35 22C19.285 22 20.023 21.749 20.564 21.247C21.104 20.744 21.374 20.061 21.374 19.197V14ZM4 0H7V2H4V0ZM0 3H11L9 7H2L0 3ZM16.845 9L18.028 5.2H15.422L14.705 6.155H14L14.466 4.495L14 2.844H14.705L15.422 3.776H18.028L16.845 0H17.777L20.155 3.777H22.761C22.958 3.777 23.125 3.846 23.261 3.982C23.3283 4.04884 23.3812 4.12874 23.4165 4.21679C23.4517 4.30485 23.4686 4.39919 23.466 4.494C23.4679 4.5871 23.451 4.67963 23.4162 4.76603C23.3815 4.85243 23.3296 4.93091 23.2638 4.99676C23.1979 5.0626 23.1194 5.11446 23.033 5.14922C22.9466 5.18397 22.8541 5.20091 22.761 5.199H20.155L17.777 9H16.845Z'
                    fill='currentColor'
                />
            </G>
            <Defs>
                <ClipPath id='clip0_10859_99577'>
                    <Rect fill='currentColor' />
                </ClipPath>
            </Defs>
        </>
    ),
})

TkuIcon.displayName = 'TkuIcon'
